<template>
  <qx-card-form title="地址信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="addressNavigationInfo" slot-scope="prop">
        <template>
          <ChooseAddressMap
            v-model="prop.form.addressNavigationInfo"
            @cc="onChangeAddressMap"
          />
        </template>
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import { queryConsignee } from 'api/distribution';
import {
  selectSysStaticDataByCodeType,
} from 'api';
import ChooseAddressMap from 'components/chooseAddressMap/chooseAddressMap';
export default {
  components: {
    ChooseAddressMap,
  },
  data () {
    return {
      otherFormData: {
        addressNavigationLat: 0,
        addressNavigationLng: 0,
        addressNavigation: '',
        provinceId: 0,
        cityId: 0,
        districtId: 0,
      },
      baseForm: {
        addressTypeOptions: [],
        inline: true,
        form: [
          {
            label: '地址类型',
            value: 'addressType',
            type: 'select',
            placeholder: '请选择地址类型',
            onChange: () => {
              this.handleAddressTypeChange();
            },
          },
          {
            label: '地址名称',
            value: 'addressName',
            type: 'input',
            placeholder: '请给地址取个容易记的名字',
          },
          {
            label: '收货方',
            value: 'consignee',
            type: 'el-autocomplete',
            hide: true,
            querySearchAsync: (queryString, cb) => {
              let resInfo = [];
              if (queryString && queryString.length) {
                queryConsignee({
                  value: queryString,
                }).then((res) => {
                  if (res && res.length) {
                    resInfo = res.map((item) => ({
                      value: item,
                    }));
                  }
                  cb(resInfo);
                });
              } else {
                cb(resInfo);
              }
            },
          },
          {
            label: '详细地址',
            value: 'addressDtl',
            type: 'input',
            placeholder: '请输入详细地址',
          },
          {
            label: '导航地址',
            value: 'addressNavigationInfo',
            default: {},
            slot: true,
          },
          {
            label: '预计停留时间',
            value: 'estimatedStayTime',
            type: 'input',
            placeholder: '请输入预计停留时间',
            unit: '分钟',
          },
        ],
        rules: {
          addressType: [
            { required: true, message: '请选择地址类型', trigger: 'blur' },
          ],
          addressName: [
            { required: true, message: '请输入地址名称', trigger: 'blur' },
          ],
          addressDtl: [
            { required: true, message: '请输入详细地址', trigger: 'blur' },
          ],
          addressNavigationInfo: [
            { required: true, message: '请输入导航地址', trigger: 'blur' },
          ],
          consignee: [
            { required: true, message: '请输入收货方名称', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      const formData = await this.sub();
      console.log(formData);
    },
    handleAddressTypeChange () {
      const addressType = this.$refs.baseForm.getVal('addressType');
      let consigneeHide = true;
      if (Number(addressType) === 1) {
        // 装货地，显示收货方
        consigneeHide = false;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: consigneeHide,
        names: ['consignee'],
      });
    },
    onChangeAddressMap (data) {
      if (data) {
        this.$refs.baseForm.setVal('addressDtl', data.address);
        this.otherFormData.addressNavigation = data.address || '';
        this.otherFormData.addressNavigationLat = data.lat || 0;
        this.otherFormData.addressNavigationLng = data.lng || 0;
        this.otherFormData.provinceId = data.provinceId || 0;
        this.otherFormData.cityId = data.cityId || 0;
        this.otherFormData.districtId = data.countryId || 0;
      }
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.addressNavigationInfo;
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          ...formData,
          ...this.otherFormData,
        };
      }
      return formData;
    },
    async getOptions () {
      if (!this.baseForm.addressTypeOptions.length) {
        const addressTypeOptions = await selectSysStaticDataByCodeType({
          codeType: 'CITY_ADDRESS_TYPE',
          hasAll: true,
        });
        this.baseForm.addressTypeOptions = addressTypeOptions.filter((item) => item.value !== '-1');
      }
    },
    async init (data = {}) {
      await this.getOptions();

      if (sessionStorage.getItem('addressType')) {
        const addressType = sessionStorage.getItem('addressType');
        sessionStorage.removeItem('addressType');
        data.addressType = String(addressType);
      }

      if (data.addressType === undefined || data.addressType === null) {
        data.addressType = this.baseForm.addressTypeOptions[0].value;
      } else {
        data.addressType = String(data.addressType);
      }

      data.addressNavigationInfo = {
        address: data.addressNavigation,
        lat: data.addressNavigationLat,
        lng: data.addressNavigationLng,
        provinceId: data.provinceId,
        cityId: data.cityId,
        countryId: data.districtId,
      };

      this.$refs.baseForm.setVal(data);
      this.setFormVal(this.otherFormData, data);
      this.handleAddressTypeChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
